import { deleteAsset, postAssetItem } from '../api'

export const assignAsset = async (asset) => {
  const response = await postAssetItem(asset)

  return {
    type: 'ASSIGN_ASSET_SUCCESS',
    data: response
  }
}

export const destroyAsset = async (asset) => {
  const response = await deleteAsset(asset)

  return {
    type: 'DESTROY_ASSET_SUCCESS',
    data: response
  }
}
